import { useNavigate } from "react-router-dom";
import { AlertTriangle } from "lucide-react";
import { useInnovation } from "@/context/InnovationContext";
import { cn } from "@/lib/utils";

// Subtle overdue / due-soon review badge for Future Innovations.
// Red = overdue, Amber = due within 7 days. Always shows a count + text (never colour alone).
export const ReviewBadge = ({ className, static: isStatic, collapsed }) => {
  const { overdue, dueSoon } = useInnovation();
  const navigate = useNavigate();

  const isOverdue = overdue > 0;
  const count = isOverdue ? overdue : dueSoon;
  if (!count) return null;

  const label = isOverdue ? `${overdue} overdue` : `${dueSoon} due soon`;
  const aria = `${count} ${isOverdue ? "overdue" : "due soon"} innovation ${count === 1 ? "review" : "reviews"}`;
  const tone = isOverdue
    ? "bg-[#DC2626]/15 text-[#B91C1C] ring-[#DC2626]/35"
    : "bg-[#E0A82E]/18 text-[#A16207] ring-[#E0A82E]/40";

  const onClick = isStatic
    ? undefined
    : (e) => { e.preventDefault(); e.stopPropagation(); navigate("/product?innovations=review"); };

  if (collapsed) {
    return (
      <span
        onClick={onClick}
        data-testid="review-badge-dot"
        title={label}
        aria-label={aria}
        className={cn("absolute right-1 top-1 flex h-4 min-w-4 items-center justify-center rounded-full px-1 text-[9px] font-bold ring-1", tone, !isStatic && "cursor-pointer", className)}
      >
        {count}
      </span>
    );
  }

  return (
    <span
      onClick={onClick}
      data-testid="review-badge"
      title={label}
      aria-label={aria}
      role={isStatic ? undefined : "button"}
      className={cn("inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-bold uppercase tracking-wide ring-1", tone, !isStatic && "cursor-pointer hover:brightness-95", className)}
    >
      <AlertTriangle size={10} strokeWidth={2.6} /> {label}
    </span>
  );
};
